import { Location } from './location';

export interface RegistrationLocation {
    id: number;
    siteId?: number | null;
    parentId?: number | null;
    type?: string | null;
    name?: string | null;
    info?: string | null;
    gpsLatitude?: number | null;
    gpsLongitude?: number | null;
    environmentClearnessLevel?: string | null;
    factorRiskLevel?: string | null;
    temperatureStress?: string | null;
    location?: RegistrationLocation | null | undefined;
}

export function toLocation(registrationLocation: RegistrationLocation): Location {
    return {
        id: registrationLocation.id,
        siteId: registrationLocation.siteId,
        parentId: registrationLocation.parentId,
        type: registrationLocation.type,
        name: registrationLocation.name,
        info: registrationLocation.info,
        gpsLatitude: registrationLocation.gpsLatitude,
        gpsLongitude: registrationLocation.gpsLongitude,
        environmentClearnessLevel: registrationLocation.environmentClearnessLevel,
        factorRiskLevel: registrationLocation.factorRiskLevel,
        temperatureStress: registrationLocation.temperatureStress,
        location: registrationLocation.location ? [toLocation(registrationLocation.location)] : null
    };
}